import { render, staticRenderFns } from "./PayBankAccount.vue?vue&type=template&id=2d82305d&scoped=true&"
import script from "./PayBankAccount.vue?vue&type=script&lang=js&"
export * from "./PayBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./PayBankAccount.vue?vue&type=style&index=0&id=2d82305d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82305d",
  null
  
)

export default component.exports